import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Fresh%20green%20cucumbers%20growing%20on%20vines%20in%20a%20sunlit%20greenhouse%2C%20organic%20agricultural%20farm%20scene%2C%20lush%20green%20foliage%20with%20tendrils%2C%20warm%20golden%20morning%20sunlight%20streaming%20through%2C%20modern%20sustainable%20farming%2C%20soft%20bokeh%20background%2C%20rich%20textural%20greens%20against%20earthy%20tones&width=1800&height=900&seq=hero-cucumber-2026&orientation=landscape"
        alt="黄瓜种植 - 专业黄瓜种植技术与市场行情平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <h1 className="font-heading font-extrabold text-3xl md:text-5xl lg:text-6xl text-white mb-4 md:mb-6 leading-tight">
          专业黄瓜种植与交易平台
        </h1>
        <p className="text-white/85 text-sm md:text-lg max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          聚焦黄瓜种植技术、品种选育、市场行情与产品交易的一站式服务平台，
          为全国黄瓜种植户、经销商和农业爱好者提供全方位信息支持。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/zhongzhi-jishu"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg font-medium text-sm transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            浏览种植技术
          </Link>
          <Link
            to="/category/shichang-hangqing"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-white border border-white/30 px-6 py-3 rounded-lg font-medium text-sm transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-chart-line"></i>
            查看市场行情
          </Link>
        </div>

        <div className="flex items-center justify-center gap-6 md:gap-10 mt-8 md:mt-10">
          {[
            { value: '50万+', label: '月活用户' },
            { value: '180+', label: '品种收录' },
            { value: '2000+', label: '技术文章' },
            { value: '35个', label: '覆盖省市' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-xl md:text-3xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/65 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}